// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.code;
  const v$1 = x.message;
  return {
    code: v !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"code\""),
    message: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"message\"")
  };
}

function to_json(x) {
  return {
    code: x.code,
    message: x.message
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
